import { render, staticRenderFns } from "./PreviewImageCard.vue?vue&type=template&id=15251519&scoped=true&"
import script from "./PreviewImageCard.vue?vue&type=script&lang=ts&"
export * from "./PreviewImageCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15251519",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
